import { postStat } from 'api/stats/stats.api'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import HeaderPeriodPicker from 'ui/components/HeaderPeriodPicker/HeaderPeriodPicker'
import DeviationSettings from 'ui/uiConfig/anchorComponents/FollowupProduction/DeviationSettings/DeviationSettings'
import Datetime from 'utils/datetime/datetime'

import { handlePeriodChange } from 'views/FollowupProductionView/FollowupProductionView'

type FollowupProductionHeaderProps = {
  period: Period
  handlePeriodChange: handlePeriodChange
  loading?: boolean
  isFollowupProduction?: boolean
}
export const followupHeaderContentClass = `followupHeaderContent`

export default function FollowupProductionHeader({
  loading,
  period,
  isFollowupProduction,
  handlePeriodChange,
}: FollowupProductionHeaderProps): ReactElement {
  const { t } = useTranslation()

  const totalDaysInPeriod = Math.ceil(Datetime.getNrOfHoursBetween(period.startTime, period.endTime) / 24)
  const maxDaysToShowDeviationSettings = 14
  return (
    <div className={`flex items-center justify-end gap-x-5 ${followupHeaderContentClass}`}>
      <div className="flex shrink-0 items-center">
        {period.startTime && period.endTime && totalDaysInPeriod <= maxDaysToShowDeviationSettings ? (
          <DeviationSettings
            startTime={Datetime.toISOString(period.startTime)}
            endTime={Datetime.toISOString(period.endTime)}
            followUp={true}
            settingsStringSuffixType="FollowupProduction"
            shrink
          />
        ) : (
          <i className="max-w-80">
            {t('Choose a period of maximum {{maxDaysToShowDeviationSettings}} days to view active deviation settings', {
              maxDaysToShowDeviationSettings,
            })}
          </i>
        )}
      </div>
      <HeaderPeriodPicker
        loading={loading}
        period={period}
        handlePeriodChange={(ev) => {
          handlePeriodChange(ev)
          postStat(`followup-header`, `change-period`)
        }}
        view="hour"
        isFollowup={isFollowupProduction}
        showTitle={false}
      />
    </div>
  )
}
